import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Modal,
  Switch,
  Row,
  Space,
  Table,
  Typography,
  Empty,
} from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import PageTitle from '../../components/PageTitle';
import IntlMessage from '../../components/IntlMessage';
import dayjs from 'dayjs';
import routesApi from '../../api/route';
import { formatCurrency, formatNumber } from '../../helpers/helpers';
import useTime from '../../hooks/useTime';
import _, { debounce } from 'lodash';
import { useIntl } from 'react-intl';
import FilterBar from '../../components/FilterBar';
import ActionBar from '../../components/ActionBar';
import RouteForm from './RouteForm';
import routeSegmentsApi from '../../api/route-segment';
import RouteCalendar from './RouteCalendar';
import PreviewSeatMap from '../seat-map/PreviewSeatmap';
import RoutePriceForm from './RoutePriceForm';
import RouteSegmentForm from './RouteSegmentForm';
import { useDispatch, useSelector } from 'react-redux';
import RouteFormReturn from './RouteFormReturn';
import RouteTrajetForm from './RouteTrajetForm';
import { message } from 'antd/lib';
import dddApi from '../../api/ddd';
import { useMounted } from '../../hooks/useMounted';

const { Text } = Typography;

const Routes = () => {
  const [form] = Form.useForm();
  const { formatAsISOString } = useTime();
  const operator = useSelector((state) => state.auth.operator);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
    filter_name: ['operator_id'],
    filter_value: [operator?.id],
  });

  const filter_route_DDD = {
    depart: '',
    arrivee: '',
    date: '',
  };
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState({
    yobuma: 0,
    cashier: 0,
    filling_rate: 0,
    pass_cashier: 0,
    pass_yobuma: 0,
  });
  const [items, setItems] = useState([]);

  const [itemSeatmap, setItemSeatmap] = useState('');
  const [openSegmentModal, setOpenSegmentModal] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [routeSelected, setRouteSelected] = useState(null);
  const [trajetModal, setTrajetModal] = useState(false);
  const [destinations, setDestinations] = useState([]);
  const [condition, setCondition] = useState(null);
  const [maps, setMaps] = useState([]);
  const [loadingSeatMap, setLoadingSeatMap] = useState(false);
  const [disabledSeat, setDisabledSeat] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [modal, setModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [updateMaps, setUpdateMaps] = useState(null);
  const [indexUpdateSegment, setIndexUpdateSegment] = useState(null);
  const [modalReturn, setModalReturn] = useState(false);
  const [loadingUpdatePriceDDD, setLoadingUpdatePriceDDD] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);

  const intl = useIntl();

  const { convertToAnyTimezone } = useTime();
  const { isMounted } = useMounted();
  const fetch = useCallback(async () => {
    if (isMounted.current) {
      setLoading(true);
      if (operator) {
        const res = await routesApi.getAllRoutesOperator(filter);
        setItems(res?.data);
        setTotal(res.total);
        setLoading(false);
      }
      setLoading(false);
    }
  }, [isMounted, filter, reload, operator]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    Promise.all([routesApi.getDestinationsOperator()]).then((res) => {
      if (Array.isArray(res[0]?.data)) {
        setDestinations(res[0]?.data);
      }
    });
  }, []);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value,
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const fetchListRouteDDD = async (record) => {
    try {
      const response = await dddApi.getListSegmentDDD({
        depart: record?.depart,
        arrivee: record?.arrivee,
        date: record?.date,
      });

      return response;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = (record) => {
    setItem(record);
    setModal(true);
  };

  const onCloseModal = () => {
    setModal(false);
  };

  const onOpenModalReturn = (record) => {
    setItem(record);
    setModalReturn(true);
  };

  const onCloseModalReturn = () => {
    setModalReturn(false);
  };

  const onOpenTrajetModal = (record) => {
    setItem(record?.segments.map((item) => JSON.parse(item.params)));
    setTrajetModal(true);
  };

  const onOpenSegmentModal = (record, routeId, index) => {
    setItem(record);
    setRouteSelected(routeId);
    setOpenSegmentModal(true);
    setIndexUpdateSegment(index);
  };

  const onOpenCalendarModal = (record, routeId) => {
    setItem(record);
    setIsOpenCalendar(true);
  };

  const onOpenPriceModal = (record, routeId) => {
    setItem(record);
    setRouteSelected(routeId);
    setOpenPriceModal(true);
  };

  const onCloseSegmentModal = () => {
    setOpenSegmentModal(false);
  };

  const onClosePriceModal = () => {
    setOpenPriceModal(false);
  };

  const onDelete = async (selectedRowKeys) => {
    await routesApi
      .delete(selectedRowKeys)
      .then(() => {
        message.success('Delete routes sucessfully');
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
    setSelectedRowKeys([]);
    onReload();
  };

  const onChangeStatus = async (isChecked, record) => {
    setLoading(true);
    await routesApi.updateStatus(record.id, {
      status: isChecked,
    });
    onReload();
    setLoading(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDisabledSeat = async (seat) => {
    setDisabledSeat((prev) =>
      _.includes(prev, seat)
        ? prev.filter((num) => num !== seat)
        : [...prev, seat],
    );
  };

  const onOpenPreviewSeatMap = (record = null) => {
    setIsPreview(true);
    setItemSeatmap(record);
  };

  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === 'search') {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          console.log('key', key);
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onCopy = async (selectedRowKeys) => {
    if (selectedRowKeys.length > 1) {
      Modal.error({
        title: 'Please select only one row',
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      return;
    }
    await routesApi.copy(selectedRowKeys).catch((error) => {
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    onReload();
  };

  const onDeleteSegment = (id) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.delete_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      okType: 'danger',
      onOk: async () => {
        await routeSegmentsApi.delete(`${id}`).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: 'global.close' }),
          });
          setLoading(false);
        });
        onReload();
      },
      onCancel() {},
    });
  };

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] },
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };
  const onChangeStatusSegment = async (isChecked, record) => {
    setLoading(true);

    try {
      await routeSegmentsApi.updateStatus(record.id, {
        status: isChecked,
      });

      setItems((data) =>
        data.map((item) => ({
          ...item,
          segments: item.segments.map((d) =>
            d.id === record.id ? { ...d, status: isChecked } : d,
          ),
        })),
      );
    } catch (error) {
      console.error('Failed to update status:', error);
    } finally {
      setLoading(false);
    }
  };

  const onChangeRouteGroupStatus = async (isChecked, record) => {
    setLoading(true);
    await routeSegmentsApi.updateGroupStatus(record.ids, {
      status: isChecked,
    });
    onReload();
    setLoading(false);
  };

  const onChangeRouteGroupStatusSegment = async (isChecked, record) => {
    setLoading(true);

    try {
      await routeSegmentsApi.updateStatus(record.id, {
        status: isChecked,
      });

      onReload();
    } catch (error) {
      console.error('Failed to update status:', error);
    } finally {
      setLoading(false);
    }
  };
  const columns_group = [
    {
      title: <IntlMessage id="global.route" />,
      key: 'start_location.title',
      sorter: true,
      dataIndex: 'start_location',
      width: 100,
      render: (_, record) => {
        const destinations = record.destinations.map((item) => item.title);
        return destinations.join(' - ');
      },
    },
    {
      title: <IntlMessage id="global.operator" />,
      key: 'operator.title',
      sorter: true,
      dataIndex: 'operator.title',
      width: 100,
      render: (_, record) => {
        return `${record?.operator?.title}`;
      },
    },

    // {
    //   title: <IntlMessage id="global.start_time" />,
    //   key: 'start_time',
    //   dataIndex: 'start_time',
    //   width: 100,
    //   render: (_, record) => {
    //     return record?.min_depart
    //       ? dayjs(record.min_depart, 'HH:mm:ss').format('HH:mm')
    //       : null;
    //   },
    // },
    {
      title: <IntlMessage id="global.status" />,
      key: 'status',
      dataIndex: 'status',
      width: 60,
      render: (e, record) => (
        <Space direction="vertical" size={2}>
          <Switch
            checkedChildren={''}
            unCheckedChildren={''}
            checked={record.routes.some((item) => item.status)}
            onChange={(isChecked) =>
              onChangeRouteGroupStatus(isChecked, record)
            }
          />
        </Space>
      ),
    },

    // {
    //   title: <IntlMessage id="global.created_at" />,
    //   key: 'created_at',
    //   dataIndex: 'created_at',
    //   width: 150,
    //   render: (text, record, index) => {
    //     return (
    //       <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
    //     );
    //   },
    // },
  ];

  const expandedRowRenderGroup = (data) => {
    console.log('data', data);
    const columns = [
      {
        title: <IntlMessage id="global.sku" />,
        key: 'sku',
        width: 100,
        sorter: true,
        dataIndex: 'sku',
        render: (text, record) => {
          return (
            <>
              <Space direction="vertical" size="small">
                <Button
                  type="link"
                  size="small"
                  // onClick={() => onOpenModal(record)}
                  onClick={() => {}}
                  shape="round">
                  {record?.sku ?? 'N/A'}
                </Button>

                {record?.segments.length > 0 ? (
                  <Button
                    size="small"
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => onOpenPriceModal(record, record.id)}
                    shape="round">
                    <IntlMessage id="global.add_price" />
                  </Button>
                ) : null}
              </Space>
            </>
          );
        },
      },
      {
        title: <IntlMessage id="global.route" />,
        key: 'start_location.title',
        sorter: true,
        dataIndex: 'start_location',
        width: 100,
        render: (_, record) => {
          const destinations = record.destinations.map((item) => item.title);
          return destinations.join(' - ');
        },
      },
      {
        title: <IntlMessage id="global.start_time" />,
        key: 'start_time',
        dataIndex: 'start_time',
        width: 100,
        render: (_, record) => {
          return record?.min_depart
            ? dayjs(record.min_depart, 'HH:mm:ss').format('HH:mm')
            : null;
        },
      },
      {
        title: <IntlMessage id="global.calendar" />,
        key: 'start_location.title',
        sorter: true,
        dataIndex: 'start_location',
        width: 100,
        render: (_, record) => {
          return (
            <Button
              type="link"
              size="small"
              onClick={() => {
                record?.segments.length > 0
                  ? onOpenCalendarModal(record)
                  : Modal.error({
                      title: 'Please create segment before',
                      okText: intl.formatMessage({ id: 'global.close' }),
                    });
              }}
              shape="round">
              <IntlMessage id="global.calendar" />
            </Button>
          );
        },
      },
      {
        title: <IntlMessage id="global.vehicle" />,
        key: 'seatmap.title',
        sorter: true,
        dataIndex: ['seatmap.title', 'seatmap', 'block_layout'],
        width: 100,
        render: (_, record) => {
          return (
            <Button
              type="link"
              size="small"
              onClick={() => onOpenPreviewSeatMap(record)}
              shape="round">
              {record?.seatmap?.title}
            </Button>
          );
        },
      },
      {
        title: <IntlMessage id="global.status" />,
        key: 'status',
        dataIndex: 'status',
        width: 130,
        render: (e, record) => (
          <Space direction="vertical" size={2}>
            <Switch
              checkedChildren={''}
              unCheckedChildren={''}
              checked={!!e}
              onChange={(isChecked) => onChangeStatus(isChecked, record)}
            />
          </Space>
        ),
      },
      {
        title: <IntlMessage id="global.id" />,
        width: 150,
        key: 'id',
        sorter: true,
        dataIndex: 'id',
        render: (text, record, index) => {
          return (
            <div style={{ textAlign: 'center' }}>
              {record.id}
              <br />
              <Text>
                Created :{' '}
                {convertToAnyTimezone(record?.created_at).format(
                  'DD/MM/YYYY HH:mm:ss',
                )}
              </Text>
            </div>
          );
        },
      },
      // {
      //   title: <IntlMessage id="global.created_at" />,
      //   key: 'created_at',
      //   dataIndex: 'created_at',
      //   width: 150,
      //   render: (text, record, index) => {
      //     return (
      //       <Text>{dayjs(record?.created_at).format('DD/MM/YYYY HH:mm')}</Text>
      //     );
      //   },
      // },
    ];

    return (
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={data.routes ?? []}
        rowKey="id"
        size="small"
        pagination={false}
        expandable={{
          expandedRowRender: expandedRowRenderGroupChild,
          defaultExpandAllRows: false,
        }}
      />
    );
  };

  const expandedRowRenderGroupChild = (data) => {
    console.log('data', data);
    const columns = [
      {
        title: '',
        key: 'id',
        width: 80,
        render: (_, record) => {
          return (
            <Flex gap={8}>
              <Button
                size="small"
                onClick={() => {
                  onOpenSegmentModal(record, record.route.id, record?.id);
                  setUpdateMaps(record?.route?.maps);
                  // console.log("this is record: ", record);
                }}
                icon={<EditOutlined />}
              />
              <Button
                danger
                size="small"
                onClick={() => onDeleteSegment(record.id)}
                icon={<DeleteOutlined />}
              />
            </Flex>
          );
        },
      },
      {
        title: <IntlMessage id="global.from" />,
        key: 'start_stop',
        dataIndex: 'start_stop',
        width: 100,
        render: (_, record) => {
          return `${record?.start_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.to" />,
        key: 'end_stop',
        dataIndex: 'end_stop',
        width: 100,
        render: (_, record) => {
          return `${record?.end_stop?.title}`;
        },
      },
      {
        title: <IntlMessage id="global.start_time" />,
        key: 'start_time',
        dataIndex: 'start_time',
        width: 50,
        render: (_, record) => {
          return record?.start_time
            ? dayjs(record.start_time, 'HH:mm:ss').format('HH:mm')
            : null;
        },
      },
      {
        title: <IntlMessage id="global.end_time" />,
        key: 'end_time',
        dataIndex: 'end_time',
        width: 50,
        render: (_, record) => {
          return record?.end_time
            ? dayjs(record.end_time, 'HH:mm:ss').format('HH:mm')
            : null;
        },
      },
      {
        title: <IntlMessage id="global.price" />,
        key: 'from_price',
        dataIndex: 'from_price',
        width: 50,
        render: (_, record) => {
          return `${record?.from_price ?? ''}`;
        },
      },
      // {
      //   title: <IntlMessage id="global.calendar" />,
      //   key: 'start_location.title',
      //   sorter: true,
      //   dataIndex: 'start_location',
      //   width: 100,
      //   render: (_, record) => {
      //     return (
      //       <Button
      //         type="link"
      //         size="small"
      //         onClick={() => onOpenCalendarSegmentModal(record)}
      //         shape="round">
      //         <IntlMessage id="global.calendar" />
      //       </Button>
      //     );
      //   },
      // },
      // {
      //   title: <IntlMessage id="global.vehicle" />,
      //   key: 'seatmap.title',
      //   sorter: true,
      //   dataIndex: ['seatmap.title', 'seatmap', 'block_layout'],
      //   width: 100,
      //   render: (_, record) => {
      //     return (
      //       <Button
      //         type="link"
      //         size="small"
      //         onClick={() => onOpenPreviewSeatMap(record?.route)}
      //         shape="round">
      //         {record?.route?.seatmap?.title}
      //       </Button>
      //     );
      //   },
      // },
      {
        title: <IntlMessage id="global.status" />,
        key: 'status',
        dataIndex: 'status',
        width: 50,
        render: (e, record) => (
          <Space direction="vertical" size={2}>
            <Switch
              checkedChildren={''}
              unCheckedChildren={''}
              checked={!!e}
              onChange={(isChecked) =>
                onChangeRouteGroupStatusSegment(isChecked, record)
              }
            />
          </Space>
        ),
      },
      {
        title: <IntlMessage id="global.id" />,
        key: 'id',
        dataIndex: 'id',
        width: 20,
        render: (_, record) => {
          return `${record?.id}`;
        },
      },
    ];

    return (
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={data.segments ?? []}
        rowKey="id_1"
        size="small"
        pagination={false}
      />
    );
  };

  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Row justify="space-between">
        <Col>
          <PageTitle title={<IntlMessage id="global.routes" />} />
        </Col>

        <Col>
          <ActionBar
            isShowAddButton={false}
            onAdd={onOpenModal}
            onCopy={() => onCopy(selectedRowKeys)}
            onRefresh={() => onReload()}
            onDelete={() => onDelete(selectedRowKeys)}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={false}
            isDisabled={!(selectedRowKeys.length > 0)}
            deleteMessage={
              'Warning! You are about to delete this route and its associated records. Are you sure you want to delete this record?'
            }></ActionBar>
        </Col>
      </Row>

      <Card bordered={false}>
        <Flex vertical gap={8}>
          <FilterBar
            onFilter={onFilter}
            textSearch={false}
            data={[
              {
                name: 'start_location',
                // data: items.map((item) => item.start_location),
                data: destinations,
                placeholder: <IntlMessage id="global.from" />,
              },
              {
                name: 'end_location',
                // data: items.map((item) => item.end_location),
                data: destinations,
                placeholder: <IntlMessage id="global.to" />,
              },
              {
                name: 'status',
                data: [
                  { title: 'Active', value: '1' },
                  { title: 'Inactive', value: '0' },
                ],
                placeholder: <IntlMessage id="global.status" />,
              },
            ]}
          />
          <Table
            dataSource={items}
            columns={columns_group}
            tableLayout="auto"
            scroll={{ x: 'max-content' }}
            loading={loading}
            onChange={onChangeTable}
            bordered
            rowKey="id"
            size="small"
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              total: total,
              current: filter.page,
              pageSize: filter.limit,
            }}
            // rowSelection={rowSelection}
            expandable={{
              expandedRowRender: expandedRowRenderGroup,
              defaultExpandAllRows: true,
            }}
            // rowSelection={rowSelection}
          />
        </Flex>
      </Card>
      {modal ? (
        <RouteForm
          open={modal}
          onClose={onCloseModal}
          currentData={item}
          onReload={onReload}
        />
      ) : null}
      {isPreview ? (
        <PreviewSeatMap
          open={isPreview}
          isModal={true}
          disabledSeat={disabledSeat}
          setDisabledSeat={setDisabledSeat}
          onClose={() => {
            setIsPreview(false);
            setDisabledSeat([]);
          }}
          onReload={onReload}
          routesData={itemSeatmap}
          handleDisabledSeat={handleDisabledSeat}
          loadingSeatMap={loadingSeatMap}
          setLoadingSeatMap={setLoadingSeatMap}
        />
      ) : null}

      {modalReturn ? (
        <RouteFormReturn
          open={modalReturn}
          onClose={onCloseModalReturn}
          currentData={item}
          onReload={onReload}
        />
      ) : null}

      {openSegmentModal ? (
        <RouteSegmentForm
          open={openSegmentModal}
          onClose={onCloseSegmentModal}
          currentData={item}
          indexUpdateSegment={indexUpdateSegment}
          updateMaps={updateMaps}
          routeId={routeSelected}
          onReload={onReload}
          maps={maps}
          setMaps={setMaps}
        />
      ) : null}

      {trajetModal ? (
        <RouteTrajetForm
          open={trajetModal}
          onClose={() => setTrajetModal(false)}
          currentData={item}
          onReload={onReload}
        />
      ) : null}

      {openPriceModal ? (
        <RoutePriceForm
          open={openPriceModal}
          onClose={onClosePriceModal}
          currentData={item}
          routeId={routeSelected}
          onReload={onReload}
          maps={maps}
          setMaps={setMaps}
        />
      ) : null}

      {isOpenCalendar ? (
        <RouteCalendar
          open={isOpenCalendar}
          onClose={() => setIsOpenCalendar(false)}
          currentData={item}
          onReload={onReload}
          reload={reload}
        />
      ) : null}
    </Card>
  );
};

export default Routes;
